import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e594375a")

_pushScopeId("data-v-e594375a")
const _hoisted_1 = { class: "award-store-container" }
const _hoisted_2 = { class: "list-wrapper" }
const _hoisted_3 = { class: "left-wrapper" }
const _hoisted_4 = { class: "right-wrapper" }
const _hoisted_5 = { class: "big" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_Back = _resolveComponent("Back")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { text: `奖品库` }),
        _createVNode(_component_Back, { onAction: _ctx.goBack }, null, 8, ["onAction"]),
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (i, k) => {
            return (_openBlock(), _createBlock("div", {
              class: "list-item",
              key: k,
              onClick: _withModifiers(($event: any) => (_ctx.doAction(i)), ["stop","prevent"])
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("img", {
                  src: i.img
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, _toDisplayString(i.name), 1),
                _createVNode("span", null, _toDisplayString(i.desc), 1),
                _createVNode("span", null, _toDisplayString(i.time), 1)
              ]),
              _createVNode("div", {
                class: `list-action ${i.isActive ? '' : 'non-active'}`
              }, [
                _createVNode("span", null, _toDisplayString(i.isActive ? "去兑换" : "已兑换"), 1)
              ], 2)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
})